import { SxProps, Theme } from '@mui/material/styles';

const MOBILE_BREAKPOINT = '@media (max-width: 640px)';

export const sponsoredTitleSX: SxProps<Theme> = {
	flex: '1 1 auto',
	minWidth: 0,
	margin: 0,
	fontSize: '18px',
	fontWeight: 900,
	lineHeight: 1.25,
	color: '#0f1111',
	textTransform: 'uppercase',
	letterSpacing: '0.2px',
	[MOBILE_BREAKPOINT]: {
		fontSize: '16px',
		lineHeight: 1.2,
		letterSpacing: '0.1px',
	},
};

export const sponsoredLinkSX: SxProps<Theme> = {
	flexShrink: 0,
	fontSize: '18px',
	fontWeight: 500,
	color: '#2682e7',
	whiteSpace: 'nowrap',
	textDecoration: 'none',
	'&:hover, &:focus-visible': { textDecoration: 'underline' },
	[MOBILE_BREAKPOINT]: {
		fontSize: '16px',
		fontWeight: 400,
	},
};

export const sponsoredProductTitleSX: SxProps<Theme> = {
	margin: 0,
	fontSize: '14px',
	fontWeight: 600,
	lineHeight: 1.5,
	color: '#2C2C2C',
	display: '-webkit-box',
	WebkitLineClamp: '2',
	WebkitBoxOrient: 'vertical',
	overflow: 'hidden',
};

export const sponsoredPricesSX: SxProps<Theme> = {
	display: 'flex',
	flexDirection: 'column',
	gap: '2px',
};

export const sponsoredPriceSX: SxProps<Theme> = {
	fontSize: '15px',
	fontWeight: 700,
	lineHeight: '20px',
	color: '#2C2C2C',
	[MOBILE_BREAKPOINT]: {
		fontSize: '15px',
	},
};

export const sponsoredPriceOldSX: SxProps<Theme> = {
	fontSize: '14px',
	fontWeight: 400,
	color: '#6b6b6b',
	textDecoration: 'line-through',
	[MOBILE_BREAKPOINT]: {
		fontSize: '14px',
	},
};
